/**Тип сетки */
export enum PickerGridTypeEnum {
  /**Минуты */
  Minutes,
  /**Часы */
  Hours,
  /**Даты */
  Dates,
  /**Месяцы */
  Months,
  /**Года */
  Years,
}